<template>
    <base-modal
        class="ingredients-modal"
        ref="ingredientsModal"
        name="ingredients-modal"
        hide-footer
        hide-header
        :title="$snippet('ingredients_modal_aria_title', 'Ingredients')"
        v-bind="$attrs"
    >
        <app-icon name="bowl" alt="" />
        <h2 class="title">
            {{ $snippet('ingredients_modal_title', '') }}
        </h2>

        <markdown-content
            :content="ingredients"
            v-test:ingredients
        />

        <markdown-content
            v-if="disclaimer"
            class="disclaimer"
            :content="disclaimer"
            v-test:disclaimer
        />

        <b-button
            variant="primary"
            @click="hideModal"
            v-test:closeBtn
        >
            {{ $snippet('ingredients_modal_close_button_text', 'continue') }}
        </b-button>
    </base-modal>
</template>

<script>
    import BaseModal from '../../molecules/BaseModal/BaseModal';
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent';

    export default {
        name: 'ingredients-modal',

        components: { BaseModal, MarkdownContent },

        props: {
            ingredients: {
                type: String,
                required: true,
            },

            disclaimer: {
                type: String,
                default: false,
            },
        },

        methods: {
            /**
             * Hide modal.
             */
            hideModal() {
                this.$refs.ingredientsModal
                    .$children[0]
                    .hide();
            },
        },
    };
</script>

<style lang="scss" scoped>
    ::v-deep .modal-body {
        text-align: center;
        @include media-breakpoint-up(lg) {
            padding: 96px 68px 101px;
        }
    }

    .app-icon {
        width: auto;
        height: 44px;
        color: transparent;
        margin-bottom: 30px;
    }

    .title {
        font-size: rem(40px);
        line-height: rem(48px);
        font-weight: 400;
        margin-bottom: 26px;
        @include media-breakpoint-up(lg) {
            font-size: rem(56px);
            line-height: rem(64px);
        }
    }

    .markdown-content {
        margin-bottom: 30px;
        font-size: rem(18px);
        line-height: rem(22.5px);

        @include media-breakpoint-up(lg) {
            font-size: rem(24px);
            line-height: rem(27px);
        }
    }

    .btn {
        min-width: 165px;
    }

    .disclaimer {
        font-weight: bold;
        font-size: rem(18px);
        line-height: rem(22.5px);

        @include media-breakpoint-up(lg) {
            font-size: rem(24px);
            line-height: rem(27px);
        }
    }
</style>
